import React from "react";
import FadeIn from "react-fade-in";

// COMPONENTS
import wildriceImg from "assets/wildrice.jpg";
import quinoaImg from "assets/quinoa.jpg";
import oatsImg from "assets/oats.jpg";
import Title from "components/layout/Title";
import Nav from "components/Nav";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Item from "../components/Item";
import SubNavLink from "../components/SubNavLink";

import {
    colorOats,
    colorWildrice,
    colorQuinoa,
} from "sass/partials/_variables.scss";

const Carbs = () => {
    return (
        <FadeIn>
            <Nav carbs={true} />
            <main>
                <article className="page">
                    <Title
                        bg="https://upload.wikimedia.org/wikipedia/commons/f/ff/Toicon-icon-avocado-harvest.svg"
                        bgSize="60%"
                        bgRepeat="no-repeat"
                        bgPos="center 80%"
                    >
                        Carbs
                    </Title>
                    <div>
                        <h2 className="introtext">So you might ask:</h2>
                        <h3 className="introtext">Why do we need them?</h3>
                        <h4 className="introtext">
                            Carbohydrates provide energy in the form of glucose,
                            or blood sugar. Glucose is necessary to support your
                            body's everyday needs and performance. But not just
                            any old carb will do; choosing wisely among
                            starches, sugars and fibers helps you maintain your
                            energy levels, avoid weight gain and combat sugar
                            crashes.
                            <sup>
                                <AnchorLink
                                    href="https://www.livestrong.com/article/414187-why-do-we-need-carbohydrates-in-our-diet/"
                                    title="content from livestrong.com"
                                >
                                    1
                                </AnchorLink>
                            </sup>
                        </h4>

                        <nav className="subnav subnav-list">
                            <SubNavLink
                                text="Oatmeal"
                                shortName="oats"
                                color={colorOats}
                            />
                            <SubNavLink
                                text="Wildrice"
                                shortName="wildrice"
                                color={colorWildrice}
                            />
                            <SubNavLink
                                text="Quinoa"
                                shortName="quinoa"
                                color={colorQuinoa}
                            />
                        </nav>
                    </div>

                    <Item
                        title="Oatmeal"
                        subtitle="100g"
                        shortName="oats"
                        color={colorOats}
                        img={oatsImg}
                        data={[
                            { name: "Kcal", stat: "389" },
                            { name: "Fiber", stat: "10,8 g" },
                            { name: "Carbs", stat: "63 g" },
                        ]}
                    />

                    <Item
                        title="Wildrice"
                        subtitle="100g"
                        shortName="wildrice"
                        color={colorWildrice}
                        img={wildriceImg}
                        data={[
                            { name: "Kcal", stat: "122" },
                            { name: "Fiber", stat: "2,1 g" },
                            { name: "Carbs", stat: "23,7 g" },
                        ]}
                    />

                    <Item
                        title="Quinoa"
                        subtitle="100g"
                        shortName="quinoa"
                        color={colorQuinoa}
                        img={quinoaImg}
                        data={[
                            { name: "Kcal", stat: "144" },
                            { name: "Fiber", stat: "2,8 g" },
                            { name: "Carbs", stat: "23,4 g" },
                        ]}
                    />
                </article>
            </main>
        </FadeIn>
    );
};

export default Carbs;
